import React, { useEffect, useRef, useState } from "react";
import Logo from "../assets/images/logo.png";
import { HelpCircle, LogOut, Settings, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Navbar = () => {
  const navigate = useNavigate();
  const email = localStorage.getItem("email");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="bg-primary py-4 text-white px-5 flex items-center justify-between">
      <a href="/QUICKFEET/">
        <div className="w-[134px] h-10">
          <img src={Logo} alt="Logo" className="w-full h-full" />
        </div>
      </a>
      <div className="relative inline-block " ref={dropdownRef}>
        <div>
          <button
            type="button"
            className="h-10 w-10 uppercase border-2 border-white rounded-full flex items-center justify-center"
            onClick={toggleDropdown}
          >
            {email?.slice(0, 1)}
          </button>
        </div>

        {isOpen && (
          <div className="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 z-50 text-gray-700 hover:bg-gray-100 hover:text-gray-900 cursor-pointer">
            <div
              className="py-1"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="options-menu"
              onClick={handleLogout}
            >
              <button
                className="flex px-4 py-2 text-sm font-medium"
                role="menuitem"
              >
                <LogOut
                  className="mr-3 h-5 w-5 text-red-600"
                  aria-hidden="true"
                />
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
